import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'github-markdown-css/github-markdown.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
